module.exports = __webpack_public_path__ + "media/images/lb/622-95175761b94be954e19d8f1a1cb61812.svg";